import React, { useState, useEffect } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import '../css/ProgramSection.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import AOS from 'aos';
import 'aos/dist/aos.css';
import certificate from '../images/certificate.jpg';
import program from '../images/program.jpg';
import assessment from '../images/assesment.avif';

const ProgramSection = () => {
    const carouselItems = [
        {
            id: 1,
            title: "Programme Explanation",
            content: `LLMS offers expert-written reading materials, videos, self-assessments, and discussion forums in five modules per course.
                Learners must spend at least 6 hours per module before taking the self-assessment (not counted for passing).
                The programme is fully online and self-paced with no offline classes.
                Learners can take the final exam anytime after 30 hours of learning, within the 180-day course duration.`,
            image: program,
            bgColor: "linear-gradient(135deg, rgba(175, 238, 252, 0.88) 40%, rgba(181, 193, 244, 0.97) 60%)"
        },
        {
            id: 2,
            title: "Self Assessment",
            content: `Examination for each Course is conducted for a maximum mark of 100. Successful completion of each Course requires the Learner to score a minimum of 50 marks out of 100. The Learner gets an Academic Credit of 2 per Course on successful completion.Section A of Question Paper for each Course comprises 50 Objective Type Questions with four choices of answers to choose the right answer.Each correct answer fetches a score of 2 (two), while for wrong answers it will be 0.5(Minus 0.5).
`,
            image: assessment,
            // image: "https://images.unsplash.com/photo-1434030216411-0b793f4b4173?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
            bgColor: "linear-gradient(135deg, rgba(181, 193, 244, 0.97) 40%, rgba(175, 238, 252, 0.88) 60%)"
        },
        {
            id: 3,
            title: "Certification",
            content: `Upon successful completion of the Programme, Learners can directly download their Certificate from the LLMS platform.
The Certificate serves as official recognition of course completion.`,
            image: certificate,
            bgColor: "linear-gradient(135deg, rgba(175, 238, 252, 0.88) 40%, rgba(181, 193, 244, 0.97) 60%)"
        }
    ];

    return (
        <div className="program-section">
            <AutoCarousel items={carouselItems} />
        </div>
    );
};

const AutoCarousel = ({ items }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isPaused, setIsPaused] = useState(false);

    useEffect(() => {
        const interval = setInterval(() => {
            if (!isPaused) {
                setCurrentIndex((prevIndex) => 
                    prevIndex === items.length - 1 ? 0 : prevIndex + 1
                );
            }
        }, 5000);

        return () => clearInterval(interval);
    }, [isPaused, items.length]);

    const nextSlide = () => {
        setCurrentIndex((prevIndex) => 
            prevIndex === items.length - 1 ? 0 : prevIndex + 1
        );
    };

    const prevSlide = () => {
        setCurrentIndex((prevIndex) => 
            prevIndex === 0 ? items.length - 1 : prevIndex - 1
        );
    };

    const goToSlide = (index) => {
        setCurrentIndex(index);
    };

    const currentItem = items[currentIndex];

    return (
        <div 
            className="auto-carousel"
            style={{ background: currentItem.bgColor }}
            onMouseEnter={() => setIsPaused(true)}
            onMouseLeave={() => setIsPaused(false)}
        >
            <div className="container h-100">
                <div className="carousel-inner h-100">
                    <div className="row align-items-center h-100">
                        <div className="col-lg-6 order-lg-1 order-2" data-aos="fade-right">
                            <div className="carousel-content">
                                <h2 className="section-title">{currentItem.title}</h2>
                                <p className="item-content">{currentItem.content}</p>
                                
                                <div className="carousel-indicators">
                                    {items.map((item, index) => (
                                        <button
                                            key={item.id}
                                            className={`indicator ${index === currentIndex ? 'active' : ''}`}
                                            onClick={() => goToSlide(index)}
                                        />
                                    ))}
                                </div>
                            </div>
                        </div>
                        
                        <div className="col-lg-6 order-lg-2 order-1" data-aos="fade-up">
                            <div className="carousel-image-container">
                                <img 
                                    src={currentItem.image} 
                                    alt={currentItem.title} 
                                    className="carousel-image"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                
                <button className="carousel-control prev" onClick={prevSlide}>
                    <FontAwesomeIcon icon={faChevronLeft} />
                </button>
                <button className="carousel-control next" onClick={nextSlide}>
                    <FontAwesomeIcon icon={faChevronRight} />
                </button>
            </div>
        </div>
    );
};

export default ProgramSection;